<template>
    <div class="equip-mana">
        <div class="head-list">
            <div class="left-item">
                <div class="my-buttom" :class="[curVal == 1 ? 'select-buttom' : '']" @click="tabChange(1)">
                    待审批
                </div>
                <div class="my-buttom" :class="[curVal == 2 ? 'select-buttom' : '']" @click="tabChange(2)">
                    已审批
                </div>
                <div class="search-item">
                    <el-form :inline="true" :model="ruleForm" size="small" ref="ruleForm" class="demo-form-inline">
                        <el-form-item label="项目名称">
                            <el-input v-model="ruleForm.projectName" maxlength="100" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="提交时间">
                            <el-date-picker format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="ruleForm.date"
                                type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="提交人">
                            <el-input v-model="ruleForm.createBy" maxlength="50"  placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="toSearch">查询</el-button>
                            <el-button  @click="resetForm('ruleForm')">重置</el-button>
                        </el-form-item>
                    </el-form>

                </div>
            </div>

        </div>
        <div class="card-content">
            <div class="comp-conent">
                <keep-alive>
                    <component :is="comName" :tableData="personList" v-loading="loading"></component>
                </keep-alive>
                <el-pagination class="el-pagination" @size-change="handleSizeChange"
                    @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="pageSizes"
                    :page-size="10" layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import stay from "./components/stay";
import already from "./components/already";
import {
    reviewStreamPage,
} from "@/api/approve.js";
export default {
    data() {
        return {
            loading: false,
            personList: [],
            ruleForm: {}, //搜索
            comName: "stay", //当前组件名称
            //分页
            currentPage: 1, //当前页数
            pageSize: 10, //页数
            curVal: 1,
            pageSizes: [10, 20, 50, 100, 200, 500, 1000], //控制每页大小
            total: 0, //总数

        };
    },
    components: {
        stay,
        already,
    },
    created() {

    },
    mounted() {
        this.getList();
    },
    methods: {
        resetForm(ruleForm){
            console.log(ruleForm)
            this.ruleForm = {}
            this.$refs[ruleForm].resetFields();
        },
        //获取仪器设备列表
        getList() {
            this.loading = true
            let params = {
                state: this.curVal,
                current: this.currentPage,
                size: this.pageSize,
                ...this.ruleForm
            }
            if (this.ruleForm.date) {
                params.startDate = this.ruleForm.date[0]
                params.endDate = this.ruleForm.date[1]
            }
            reviewStreamPage(params)
                .then((res) => {
                    this.loading = false
                    if (res.code == 200) {
                        this.personList = res.data.pageData.records;
                        this.total = res.data.pageData.total;
                    }
                })
                .finally(() => {
                });
        },
        handleClick(index) {
        },

        tabChange(index) {
            if (index != this.curVal) {
                this.ruleForm = {};
                this.currentPage = 1;
                this.personList = [];
                this.curVal = index;
                switch (index) {
                    case 1:
                        this.comName = "stay";
                        break;
                    case 2:
                        this.comName = "already";
                        break;
                    default:
                        break;
                }
                this.getList();
            }
        },
        //分页功能
        handleCurrentChange(page) {
            this.currentPage = page;
            this.getList();
        },
        handleSizeChange(page) {
            this.currentPage = 1;
            this.pageSize = page;
            this.getList();
        },

        toSearch() {
            this.currentPage = 1;
            this.personList = [];
            this.getList();
        },



    },
    watch: {

    },
};
</script>

<style lang='less' scoped>
.tips {
    background: linear-gradient(180deg,
            rgba(49, 210, 255, 0.52),
            rgba(0, 57, 142, 0.52));
    color: #74c8fe;
}

//按钮样式
.el-button {
    background: url(~@/assets/images/btn.png) no-repeat center;
    background-size: 100% 100%;
    border: none;
    color: #74c8fe;
}

.btn {
    cursor: pointer;
}


.el-pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 10px;

    /deep/ .el-pagination__total {
        color: #fff !important;
    }

    /deep/ .el-pagination__jump {
        color: #fff;
    }
}

.equip-mana {
    width: 100%;
    color: #74c8fe;

    /deep/ .el-form-item__label {
        color: #fff;
    }

    .head-list {
        display: flex;
        justify-content: space-between;
        box-sizing: border-box;

        .search-item {
            width: 100%;
            margin-top: 10px;

            .myinput {
                width: 300px;
            }

            .element-list {
                border: 2px solid #0090f0;
                border-radius: 6px;
                height: 30px;
                width: 150px;
                line-height: 30px;
                text-align: center;

                /deep/ .el-input__inner {
                    background-color: rgba(0, 0, 0, 0);
                    color: #fff;
                    border: 0px;
                    border-radius: 0px;
                    text-align: center;
                }

                /deep/ input::-webkit-input-placeholder {
                    color: #74c8fe;
                }

                /deep/ input::-moz-input-placeholder {
                    color: #74c8fe;
                }

                /deep/ input::-ms-input-placeholder {
                    color: #74c8fe;
                }


            }
        }
    }



    // 公共样式
    .selec {
        background-image: linear-gradient(#0479b4, #02407e);
    }
}

.jb-bg {
    background-image: linear-gradient(#0479b4, #02407e);
}
</style>


// WEBPACK FOOTER //
// src/views/approvalManagement/index.vue